export const COUNTRIES_LIST = [
    'ar',
    'uy',
    'es',
    'mx',
    'py',
    'cl',
    'co',
    'ec',
    'bo',
    'pe',
    've',
    'bz',
    'cr',
    'sv',
    'gt',
    'hn',
    'ni',
    'pa',
    'cu',
    'do',
    'pr',
];
export const COUNTRIES_LIST_DEFAULT_PREFIX = [
    {
        name: 'Argentina',
        code: 'ar',
    },
    {
        name: 'Uruguay',
        code: 'uy',
    },
    {
        name: 'Espana',
        code: 'es',
    },
    {
        name: 'Mexico',
        code: 'mx',
    },
    {
        name: 'Paraguay',
        code: 'py',
    },
    {
        name: 'Chile',
        code: 'cl',
    },
    {
        name: 'Colombia',
        code: 'co',
    },
    {
        name: 'Ecuador',
        code: 'ec',
    },
    {
        name: 'Bolivia',
        code: 'bo',
    },
    {
        name: 'Peru',
        code: 'pe',
    },
    {
        name: 'Venezuela',
        code: 've',
    },
    {
        name: 'Belice',
        code: 'bz',
    },
    {
        name: 'Costa Rica',
        code: 'cr',
    },
    {
        name: 'El Salvador',
        code: 'sv',
    },
    {
        name: 'Guatemala',
        code: 'gt',
    },
    {
        name: 'Honduras',
        code: 'hn',
    },
    {
        name: 'Nicaragua',
        code: 'ni',
    },
    {
        name: 'Panama',
        code: 'pa',
    },
    {
        name: 'Cuba',
        code: 'cu',
    },
    {
        name: 'Republica Dominicana',
        code: 'do',
    },
    {
        name: 'Puerto Rico',
        code: 'pr',
    },
];

// Shortest valid number (country calling code + national number, digits only) for each dial code
// in COUNTRIES_LIST. Dial codes are matched longest first.
const PHONE_MIN_LENGTH_BY_DIAL_CODE: Record<string, number> = {
    '54': 12, // ar
    '598': 11, // uy
    '34': 11, // es
    '52': 12, // mx
    '595': 12, // py
    '56': 11, // cl
    '57': 12, // co
    '593': 11, // ec
    '591': 11, // bo
    '51': 10, // pe
    '58': 12, // ve
    '501': 10, // bz
    '506': 11, // cr
    '503': 11, // sv
    '502': 11, // gt
    '504': 11, // hn
    '505': 11, // ni
    '507': 10, // pa
    '53': 10, // cu
    '1': 11, // do, pr
};

/**
 * Minimum digits a phone number needs, given the country it starts with. Never stricter than
 * `defaultMinLength`, so it only relaxes the check for countries with shorter numbers.
 */
export function getPhoneMinLength(phone: string | undefined | null, defaultMinLength: number): number {
    const digits = (phone ?? '').replace(/\D/g, '');
    const dialCode = Object.keys(PHONE_MIN_LENGTH_BY_DIAL_CODE)
        .sort((a, b) => b.length - a.length)
        .find((code) => digits.startsWith(code));
    if (!dialCode) {
        return defaultMinLength;
    }
    return Math.min(defaultMinLength, PHONE_MIN_LENGTH_BY_DIAL_CODE[dialCode]);
}
